import React, { Component } from "react";
import AdminBar from "./AdminBar/AdminBar";
import { withStyles } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import Hidden from "@material-ui/core/Hidden";
import Drawer from "@material-ui/core/Drawer";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";

import { useStyles } from "./AdminHeader.css";
import MenuDrawer from "./MenuDrawer/MenuDrawer";

class AdminHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mobileOpen: false,
    };
  }

  handleDrawerToggle = () => {
    this.setState({
      mobileOpen: !this.state.mobileOpen,
    });
  };

  render() {
    const { classes, container } = this.props;
    return (
      <div className={classes.root}>
        <CssBaseline />
        <AdminBar handleDrawerToggle={this.handleDrawerToggle} />
        <div className={classes.drawer}>
          <Hidden smUp implementation="css">
            <Drawer
              container={container}
              variant="temporary"
              anchor={classes.theme ? "left" : "right"}
              open={this.state.mobileOpen}
              onClose={this.handleDrawerToggle}
              classes={{
                paper: classes.drawerPaper,
              }}
              ModalProps={{
                keepMounted: true,
              }}
            >
              <AppBar
                position="fixed"
                className={classes.toolbar}
                elevation={0}
              >
                <Toolbar
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    fontSize: 25,
                    backgroundColor: "#0a1f3a",
                  }}
                >
                  Admin Panel
                </Toolbar>
              </AppBar>
              <MenuDrawer />
            </Drawer>
          </Hidden>

          <Hidden smDown implementation="css">
            <Drawer
              classes={{
                paper: classes.drawerPaper,
              }}
              variant="permanent"
              open
            >
              <AppBar
                position="fixed"
                className={classes.toolbar}
                style={{ background: "#184c98", fontSize: 15 }}
                elevation={0}
              >
                <Toolbar
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    fontSize: 25,
                    backgroundColor: "#0a1f3a",
                  }}
                >
                  Admin Panel
                </Toolbar>
              </AppBar>
              <MenuDrawer />
            </Drawer>
          </Hidden>
        </div>
      </div>
    );
  }
}

export default withStyles(useStyles)(AdminHeader);
